<div class="row">
    <div class="col">
        <app-add-new-region [regionsList]="regionsList" [countriesList]="countriesList" [countriesOptions]="countriesOptions"></app-add-new-region>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Name</th>
                        <th scope="col">Country</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let region of regionsList; let i = index">
                        <tr [ngClass]="{'bluBottomLine': i === regionsList.length - 1}">
                            <ng-container *ngIf="choosenEditRegion.id === region.id; else displayTemplate">
                                <td colspan="4">
                                    <app-edit-region-form [region]="choosenEditRegion" [regionsList]="regionsList" [countriesList]="countriesList" [countriesOptions]="countriesOptions" (getCancelEditModeEvent)="cancelRegionEditMode()" (geResetRegionsList)="resetRegionsList($event)">
                                    </app-edit-region-form>
                                </td>
                            </ng-container>
                            <ng-template #displayTemplate>
                                <td scope="row">{{region.id}}</td>
                                <td>{{region.name}}</td>
                                <td>
                                    {{region.country.name}}
                                </td>
                                <td class="text-right">
                                    <div class="btn-group btn-group-sm" role="group" aria-label="Button group with nested dropdown">
                                        <button type="button" class="btn btn-link" title="Edit" (click)="enableEditRegion(region)"><i class="fa fa-edit"></i></button>
                                        <!--
                                        <button type="button" class="btn btn-link" placement="top" [ngbTooltip]="Delete" (click)="showConfirmDeleteDialog(region.id)"><i class="fa fa-trash"></i></button>
                                        -->
                                    </div>
                                </td>
                            </ng-template>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
<app-confirm-dialog-model #confirmDeleteRegionDialog (getResult)="getDeleteRegionDecision($event)" modalTitle="Region Elimination" modalContent="Do you want to delete this region?" denyText="NO" acceptText="YES">
</app-confirm-dialog-model>
